<template>
    <div id="orderConfirm">
        <table-title>归还预约确认</table-title>
        <Form :model="formData" ref="formValidates" :label-width="110" inline :rules="rulesFormData">
            <FormItem label="归还预约单号">
                <Input v-model="formData.id" disabled style="width: 180px" />
            </FormItem>
            <FormItem label="租借人">
                <Input v-model="formData.leaseeId" disabled style="width: 180px" />
            </FormItem>
            <br />
            <FormItem label="标的物小类">
                <Input v-model="formData.targetType" disabled style="width: 180px" />
            </FormItem>
            <FormItem label="租借方联系人">
                <Input v-model="formData.contactId" disabled style="width: 180px" />
            </FormItem>
            <br />
            <FormItem label="预约归还总数">
                <Input v-model="formData.totalAmount" disabled style="width: 180px" />
            </FormItem>
            <FormItem label="回收数量">
                <Input v-model="formData.recycledAmount" disabled style="width: 180px" />
            </FormItem>
            <br />
            <FormItem label="回收方式">
                <Input v-model="formData.recycleMethod" disabled style="width: 180px" />
            </FormItem>
            <FormItem label="确认结果" prop="result">
                <dict-select namespace="ENUM_MID-OPERATE-LEASE" id="recycleService.RecycleAppointmentConfirmResult" :width="180" :exclusion="[]" v-model="formData.result" />
            </FormItem>
            <br />
            <FormItem label="计费截止日" v-if="formData.result === 'OK'" :prop="row.recycleMethod ==='SELF_DELIVERY'?'':'billingUntil'">
                <DatePicker @on-change="onRecycledTime" type="date" :editable="false" v-model="formData.billingUntil" placeholder="请选择计费截止日" style="width: 180px"></DatePicker>
            </FormItem>
            <FormItem label="客户自送仓库" v-if="row.recycleMethod === 'SELF_DELIVERY' && formData.result === 'OK'" prop="selfDeliveryStorageId">
                <dict-select namespace="bizObjects" id="warehouse" :width="180" v-model="formData.selfDeliveryStorageId" @on-change="onStorage" :exclusion="[]" />
            </FormItem>
            <br />
            <FormItem label="备注">
                <Input v-model="formData.recycleAppointmentAckComment" type="textarea" style="width:480px" />
            </FormItem>
        </Form>
        <template v-if="sleclectPickShow">
            <table-title>
                关联起租交付计划
                <Button type="success" style="margin-left:10px" size="small" :disabled="dataPick.length>0?true:false" @click="onSelectPick">选择交付计划</Button>
            </table-title>
            <data-grid v-if="pickShow" :columns="colsPick" :queryParams="{}" :pagination="false" :autoLoad="false" subListName :dataList="dataPick">
                <template #default="{columns, data}">
                    <Table :columns="columns" :data="data" border stripe size="small">
                        <template slot-scope="{row}" slot="status">
                            <Tag color="gold" v-if="row.status === 'NORMAL'">正常</Tag>
                            <Tag color="green" v-if="row.status === 'FINISH'">完成</Tag>
                            <Tag color="blue" v-if="row.status === 'TERMINATE'">中止</Tag>
                        </template>
                        <template #option="{row,index}">
                            <Button type="error" size="small" @click="dataPick.splice(index,1)">删除</Button>
                        </template>
                    </Table>
                </template>
            </data-grid>
        </template>
        <table-title v-if="formData.result === 'OK'">停租合约列表</table-title>
        <data-grid v-if="formData.result === 'OK' && tableShows" :columns="colsTwo" :queryParams="{}" :pagination="false" :autoLoad="false" :pageNum="1" :pageSize="50" subListName :dataList="dataListTwo">
            <template #default="{columns, data}">
                <!-- @on-select-all="allSelectTwo" @on-selection-change="onSelectionChangeTwo" @on-select-all-cancel="onAllCancelTwo" -->
                <Table border :columns="columns" :data="data">
                    <template slot-scope="{row,index}" slot="totalAmount">
                        <p>
                            <span>最大可停租数量：</span>
                            <span style="color:red">{{dataMax[index].remainAmount}}</span>
                        </p>
                        <InputNumber :min="1" :max="dataMax[index].remainAmount" :value="data[index].totalAmount" @on-change="onChangeNum($event,index)" style="width:130px"></InputNumber>
                    </template>
                </Table>
            </template>
        </data-grid>
        <table-title v-if="formData.result === 'OK'">核销报损记录列表</table-title>
        <data-grid v-if="formData.result === 'OK' && tableShow" :columns="cols" :queryParams="{}" :pagination="false" :autoLoad="false" :pageNum="1" :pageSize="1" subListName :dataList="dataList">
            <template #default="{columns, data}">
                <Table border :columns="columns" :data="data" @on-select-all="allSelect" @on-selection-change="onSelectionChange" @on-select-all-cancel="onAllCancel">
                    <template slot-scope="{row}" slot="notAmount">
                        {{
                        (()=>{
                        return row.breakAmount - row.recycledAmount
                        })()
                        }}
                    </template>
                </Table>
            </template>
        </data-grid>
        <div style="text-align:center">
            <Button type="primary" @click="affirm">确认</Button>
            <Button type="warning" style="margin-left:5px" @click="goBlack">返回</Button>
        </div>
        <select-delivery ref="selectDeluveryRef" @onCurrent="onCurrent"></select-delivery>
    </div>
</template>

<script>
import dictSelect from '@/components/select/dict-select.vue'
import tableTitle from "@/components/tableTitle/tableTitle"
import dataGrid from '@/components/datagrid.vue'
import selectDelivery from '@/components/selectDelivery.vue'

export default {
    props: ['paramsData'],
    components: {
        dictSelect,
        tableTitle,
        dataGrid,
        selectDelivery
    },
    data() {
        return {
            sleclectPickShow: false,//是否选择关联交付计划
            dataPick: [],//交付计划
            storaDetail: {},//仓库详情信息
            pickShow: true,
            row: [],
            dataList: [],
            recycleList: [],//已选择停租合约列表
            dataListTwo: [],
            dataMax: [],
            tableShow: false,
            tableShows: false,
            leaseeId: '',
            targetType: '',
            breakReportIds: [],//核销报损列表
            contracts: [],//停租合约
            formData: {
                id: '',
                result: 'OK',
                billingUntil: "",
                // recycleCostUnit: "",//回收费单价
                leaseeId: '',
                targetType: '',
                recycleMethod: '',
                contactId: '',
                totalAmount: '',
                recycledAmount: '',
                selfDeliveryStorageId: "",//客户自送仓库
                recycleAppointmentAckComment: "",//备注

            },
            rulesFormData: {
                result: [{ required: true, message: '请选择确认结果', trigger: 'change' }],
                billingUntil: [{ required: true, message: '请选择计费截止日', trigger: 'change' }],
                // recycleCostUnit: [{ required: true, message: '请输入回收费单价' }]
                selfDeliveryStorageId: [{ required: true, message: '请选择客户自提仓库', trigger: 'change' }],
            },
            cols: [
                { type: 'selection', width: 50 },
                { title: '报损数量', key: "breakAmount" },
                { title: '已回收数量', key: "recycledAmount" },
                { title: '未回收数量', slot: "notAmount" },
                { title: '计费截止日', key: "billingUntil", formatter: 'date' },],
            colsTwo: [
                { type: 'selection', width: 50 },
                { title: '合约id', key: "id" },
                { title: '租借人', key: "leaseeId", dict: ['bizObjects', 'member', true] },
                { title: '合伙人', key: "leaserId", dict: ['bizObjects', 'member', true] },
                { title: '计费模式', key: "modelId", dict: ['default', 'billingModel', true] },
                { title: '起租数量', key: "amount" },
                { title: '可停租数量', slot: "totalAmount", width: 150 },
                { title: '租期', key: "rentTerm" },
                { title: '开始计租日', key: "billingStartDate" },
                { title: '租借人最小停租时间', key: "leaseeMinBillingStopDate" },
            ],
            colsPick: [
                { title: '订单号', key: 'orderNo' },
                { title: '交付计划编号', key: 'id' },
                { title: '仓库名称', key: 'storageId', dict: ['bizObjects', 'warehouse', true] },
                { title: '租借人', key: 'leaseeId', dict: ['bizObjects', 'member', true] },
                { title: '标的物小类', key: 'targetType', dict: ['target', 'type', true] },
                { title: '标的物编码', key: 'targetCode', dict: ['target', 'code', true] },
                { title: '交付计划总数量', key: 'totalAmount' },
                { title: '已交付数量', key: 'finishAmount' },
                { title: '状态', slot: 'status' },
                { title: '交付方式', key: 'deliveryMethod', dict: ['ENUM_MID-OPERATE-LEASE', 'order.DeliveryMethod'] },
                { title: '操作', slot: 'option' }]
        }
    },
    created() {
        this.row = this.paramsData
        this.leaseeId = this.row.leaseeId
        this.targetType = this.row.targetType
        this.formData.recycleMethod = this.$options.filters['queryDict']('ENUM_MID-OPERATE-LEASE', 'recycleAppointment.RecycleMethod', this.row.recycleMethod)
        this.getRecycle(this.paramsData.id)

    },
    async mounted() {
        await this.dict.initDict([{ id: 'contact', namespace: 'bizObjects', }, { id: 'warehouse', namespace: 'bizObjects', }]); // 初始化字典

        this.formData.id = this.row.id
        this.formData.leaseeId = this.$options.filters['queryDict']('bizObjects', 'member', this.row.leaseeId)
        this.formData.targetType = this.$options.filters['queryDict']('target', 'type', this.row.targetType)
        this.formData.contactId = this.$options.filters['queryDict']('bizObjects', 'contact', this.row.contactId)
        this.formData.totalAmount = this.row.totalAmount
        this.formData.recycledAmount = this.row.recycledAmount
        this.getData()
        this.getStopBilling()
    },
    methods: {
        // 全选
        allSelect(selection) {
            this.breakReportIds = selection
        },
        // 不全选
        onAllCancel(selection) {
            this.breakReportIds = selection
        },
        // 一项改变时触发
        onSelectionChange(selection) {
            this.breakReportIds = selection
        },
        onRecycledTime(val) {
            this.formData.billingUntil = val
        },
        // allSelectTwo(selection) {
        //     this.contracts = selection
        // },
        // onAllCancelTwo(selection) {
        //     this.contracts = selection
        // },
        // onSelectionChangeTwo(selection) {
        //     this.contracts = selection
        //     // console.log(this.contracts)
        // },
        onChangeNum(val, index) {
            let row = this.dataListTwo[index]
            row.totalAmount = val
            row._checked = true
            this.$set(this.dataListTwo, index, row)

            if (!this.dataListTwo[index].totalAmount) {
                let data = this.dataListTwo[index]
                data._checked = false
                this.$set(this.dataListTwo, index, data)

            }


        },
        // 选择交付计划
        onSelectPick() {
            let obj = {
                storageId: this.formData.selfDeliveryStorageId,
                targetType: this.paramsData.targetType,
                leaseeId: this.storaDetail.memberId,
                targetCode: "-",
                qualityType: "UNKNOWN",
                deliveryMethod: "DOORSTEP",
                status: "NORMAL"
            }
            this.$refs['selectDeluveryRef'].openModal(obj)
        },
        // 选择交付计划回调
        onCurrent(params) {
            this.pickShow = false
            setTimeout(() => {
                this.dataPick.push(params)
                this.pickShow = true
            }, 50)

        },
        // 客户自送选择仓库
        async onStorage(val) {
            await this.storageDetail(val)
            console.log(this.storaDetail)
            if (this.row.recycleMethod === 'SELF_DELIVERY' && this.storaDetail.memberId != this.paramsData.leaseeId && this.storaDetail.type === "OUTER") {
                this.sleclectPickShow = true
            } else {
                this.sleclectPickShow = false
            }

        },
        // 查询仓库详情信息
        async storageDetail(storageId) {
            let data = {
                url: "CORE-STORAGE/messageService/baseInfoService/queryStorageBaseInfo",
                body: { storageId }
            }
            await this.invoke(data).then(res => {
                this.storaDetail = res
            })
        },
        // 核损报损记录
        async getData() {
            let data = {
                url: 'MID-OPERATE-LEASE/messageService/recycleService/queryBreakReportsForRecycle',
                body: { leaseeId: this.leaseeId, targetType: this.targetType }
            }
            this.tableShow = false
            await this.invoke(data).then(res => {
                this.tableShow = true
                res.map(item => {
                    this.breakReportIds.push({ id: item.id })
                    return item._checked = true
                })
                this.dataList = res
            })
        },
        // 停租合约列表
        getStopBilling() {
            let data = {
                url: 'MID-OPERATE-LEASE/messageService/recycleService/queryContractListToStopBilling',
                body: { params: { leaseeId: this.leaseeId, targetType: this.targetType } }
            }
            this.tableShows = false
            this.invoke(data).then(res => {
                this.tableShows = true
                this.dataListTwo = res
                this.dataListTwo.forEach((item, index) => {
                    this.dataListTwo[index].totalAmount = '';
                    this.dataListTwo[index]._checked = false;
                    this.recycleList.forEach(ele => {
                        if (item.id === ele.contractNo) {
                            this.dataListTwo[index]._checked = true
                            this.dataListTwo[index].totalAmount = ele.totalAmount

                        }
                    })
                })
                this.dataMax = JSON.parse(JSON.stringify(res))
            })

        },
        // 已选择停租合约
        getRecycle(recycleAppointmentId) {
            this.recycleList = []
            let data = {
                url: 'MID-OPERATE-LEASE/messageService/recycleService/queryRecycleAppointmentContractApplys',
                body: { recycleAppointmentId }
            }
            this.invoke(data).then(res => {
                // console.log(res)
                this.recycleList = res
            })
        },

        affirm() {
            this.$refs['formValidates'].validate((valid) => {
                if (valid) {
                    var contracts = []
                    var breakReportIds = []
                    // 确认结果拒绝
                    if (this.formData.result === 'OK') {
                        this.dataListTwo.map(item => {
                            if (item._checked) {
                                let obj = {
                                    contractNo: item.id,
                                    amountForStopBilling: item.totalAmount,
                                }
                                contracts.push(obj)
                            }
                        })
                        this.breakReportIds.map(item => {
                            breakReportIds.push(item.id)
                        })

                    } else {
                        let objs = {
                            contractNo: "",
                            amountForStopBilling: 0
                        }
                        contracts.push(objs)
                        breakReportIds = []
                        this.formData.billingUntil = ''
                        this.formData.selfDeliveryStorageId = ""

                    }

                    let data = {
                        url: 'MID-OPERATE-LEASE/messageService/recycleService/recycleAppointmentConfirm',
                        body: {
                            appointmentId: this.formData.id,
                            billingUntil: this.formData.billingUntil,
                            breakReportIds: breakReportIds,
                            contracts: contracts,
                            // recycleCostUnit: this.formData.recycleCostUnit,
                            result: this.formData.result,
                            selfDeliveryStorageId: this.formData.selfDeliveryStorageId,
                            relativeDeliveryPlanId: this.dataPick.length > 0 ? this.dataPick[0].id : "",
                            recycleAppointmentAckComment: this.formData.recycleAppointmentAckComment
                        }
                    }

                    this.$Modal.confirm({
                        title: '确定要预约归还吗?',
                        onOk: () => {
                            this.invoke(data).then(res => {
                                // this.$Message.success('预约归还成功！')
                                this.goBlack()
                                this.formData.recycleAppointmentAckComment = ""
                            })

                        },
                    });


                }
            })

        },
        // 返回
        goBlack() {
            this.$emit("onFinish")
        },
    }

}
</script>